import Vue from 'vue'
import VueRouter from 'vue-router'
import config from '../config'
import { setAppTitleBar } from '../components/app'
import Bus from '../utils/bus'
Vue.use(VueRouter)

/*
  路由懒加载
*/
const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/index'),
    meta: { title: '笔尖上的少年' }
  },
  {
    path: '/apply',
    name: 'apply',
    component: () => import('../views/apply.vue'),
    meta: { title: '报名作文活动' }
  },
  {
    path: '/personalList',
    name: 'personalList',
    component: () => import('../views/personalList.vue'),
    meta: { title: '我的征文' }
  },
  {
    path: '/articleDetail',
    name: 'articleDetail',
    component: () => import('../views/articleDetail.vue'),
    meta: { title: '作文详情' }
  },
  {
    path: '/helpPage',
    name: 'helpPage',
    component: () => import('../views/helpPage.vue'),
    meta: { title: '笔尖上的少年' }
  },
  {
    path: '/addAddress',
    name: 'addAddress',
    component: () => import('../views/addAddress.vue'),
    meta: { title: '填写地址' }
  },
  {
    path: '/rules',
    name: 'activityrules',
    component: () => import('../views/rules/index'),
    meta: { title: '活动规则' }
  },
  {
    path: '/upload',
    name: 'articleUpload',
    component: () => import('../views/upload/index'),
    meta: { title: '上传作文' }
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('../views/demo'),
    meta: { title: '上传作文' }
  },
  {
    path: '/bangdan',
    name: 'bangdan',
    component: () => import('../views/bangdan'),
    meta: { title: '全国榜单' }
  },
  {
    path: '/fuxuan',
    name: 'fuxuan',
    component: () => import('../views/fuxuan'),
    meta: { title: '复选名单' }
  },
  {
    path: '/juesheng',
    name: 'juesheng',
    component: () => import('../views/juesheng'),
    meta: { title: '决胜名单' }
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.afterEach(to => {
  document.title = to.meta.title || '学而思网校'
  const pageConfig = config.xesLog.pages[to.name]
  console.log('to.name', to.name, pageConfig)
  if (pageConfig) {
    setTimeout(() => {
      /*
        每个页面配置统一的 pageuid、pagename、pagelevel
        页面中发埋点日志时，不需要再单独配置如上参数
      */
      Vue.prototype.$xesLogger.setCommonParam({
        pageuid: pageConfig.uid,
        pagename: pageConfig.name,
        from: window._wltfChannel.urlParams.from || 'web',
        inviterId: window._wltfChannel.urlParams.inviterId || ''
      })
      // 进入页面时发送展现日志
      Vue.prototype.$xesLogger.loadMsg()
    }, 300)
  }
  window.xesApp &&
    setAppTitleBar(
      {
        title: to.meta.title || '学而思网校',
        icon: 'https://editor.xesimg.com/tailor/resource/fx4-1623223652680.png'
      },
      () => {
        Bus.$emit('share')
      }
    )
})

export default router
